import React from "react";

const BusinessSummary = () => {
    return <div>Business Summary</div>;
};

export default BusinessSummary;
